import type { CaseKind } from '@/core/types/cases';

export const clientCaseKindLabels: Record<CaseKind, string> = {
	identity_verification: 'Identity verification',
	information_request: 'Information request',
	additional_documents: 'Additional documents',
	payment_information_request: 'Payment information request',
};

export const clientCaseKindOptions = Object.entries(clientCaseKindLabels).map(([value, label]) => ({
	value,
	label,
}));

export const creatableClientCaseKindOptions = Object.entries(clientCaseKindLabels)
	.filter(([value]) => value !== 'additional_documents')
	.map(([value, label]) => ({
		value,
		label,
	}));
